var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaelogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 339,
    height: 332,
    viewBox: "0 0 339 332",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M169.5 332C263.112 332 339 257.679 339 166C339 74.321 263.112 0 169.5 0C75.888 0 0 74.321 0 166C0 257.679 75.888 332 169.5 332Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M241.154 127.142L260.308 89L300 148.092L256.154 237H210L256.154 148.092L241.154 127.142Z",
    fill: "#1375BC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M224 89L189.942 163L155.885 237H114L182.327 89H224Z",
    fill: "#24AAE1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.035 199.184L85.649 237L43 177.319L87.93 95H134L88.614 177.319L105.035 199.184Z",
    fill: "#1375BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaelogo);
export default __webpack_public_path__ + "static/media/maelogo.f683a57a5a9118d6c6794f45daf024e5.svg";
export { ForwardRef as ReactComponent };